<template>
    <div class="image product-img">
 
                
         <img v-for="(layer_info,index) in photoDatas" :key="index" :class="{'product-img-inner':index>0}" @load="photosLoaded+=1" :style="'opacity:'+getOpacityElement(layer_info)+';'" :src='calculatePhoto(layer_info)'
     
     />
    </div>
     
                         
 </template>
 
 <script>
 
 
 import { APIRequest } from "@simb2s/senseye-sdk"
 export default {
     name: "CartImageComponent",
     props: ["cart_item"],
     components: {
         
   },
     methods: {
 
         getBrightnessElement(layer_info) {
             if(layer_info.presets.brightness != null) {
                 return layer_info.presets.brightness/100
             }
             else {
                 return 1
             }
         },
         getHueElement(layer_info) {
             if(layer_info.presets.hue != null) {
                 return layer_info.presets.hue/1.7
             }
             else {
                 return 0
             }
         },
         getSaturationElement(layer_info) {
             if(layer_info.presets.saturation != null) {
                 return layer_info.presets.saturation/100
             }
             else {
                 return 1
             }
         },
         
         getOpacityElement(layer_info) {
             if(layer_info.presets.opacity != null) {
                 return layer_info.presets.opacity/100
             }
             else {
                 return 1
             }
         },
 
         async getModelParts(){
 
             let cart_item=this.cart_item
 
             let request_modelparts = '?glass='+cart_item.glass.id
             let model_partss =  await APIRequest.list_with_request('model-parts',request_modelparts)
             
             this.model_parts = model_partss[0]
         },
         async getRenderInfos(){
             let cart_item=this.cart_item
            
             let model_parts = this.model_parts
             
             let request='?glass='+cart_item.glass.id+'&branch=4'
 
             for(let i=0;i<model_parts.length;i++) {
        
                 if(model_parts[i].render_type!="shadow" && model_parts[i].render_type!="hinge"){
                     if(model_parts[i].type=='color') {
                         if(model_parts[i].render_slug=="frame")
                         {
                         // ON parcoure les order cart_item customizations pour voir si il y a le meme id que le model part courant
                         let founded=false
                         // Si oui on precise le param
                             for(let k=0;k<cart_item.order_item_customizations.length;k++)
                             {
                                 if(cart_item.order_item_customizations[k].model_part.id==model_parts[i].id)
                                 {
                                     request+='&color_'+model_parts[i].render_slug+'='+cart_item.order_item_customizations[k].color.id
                                     request+='&texture_style_'+model_parts[i].render_slug+'=0'
                                 
                                 //   params['color_'+model_parts[i].render_slug]=cart_item.order_cart_item_customizations[k].color.id
                                 //   params['texture_style_'+model_parts[i].render_slug]=0
                                 founded=true
                                 }
                                 
                             }
                             if(founded==false) {
                                 if(model_parts[i].material=="plastic")
                                 {
                                     request+='&color_'+model_parts[i].render_slug+'=10'
                                 //  params['color_'+model_parts[i].render_slug]=10
                                 }
                                 else {
                                     request+='&color_'+model_parts[i].render_slug+'=19'
                                 //params['color_'+model_parts[i].render_slug]=23
                                 }
                                 
                             }
                         
                         }
                         else if(model_parts[i].render_slug=="temples") {
                             let founded=false
                             for(let k=0;k<cart_item.order_item_customizations.length;k++)
                             {
                                 if(cart_item.order_item_customizations[k].model_part.id==model_parts[i].id)
                                 {
                                     request+='&color_'+model_parts[i].render_slug+'='+cart_item.order_item_customizations[k].color.id
                                 //params['color_'+model_parts[i].render_slug]=cart_item.order_cart_item_customizations[k].color.id
                             
                                 founded=true
                                 }
                             }
     
                             if(founded==false) {
                                 if(model_parts[i].material=="plastic")
                                 {
                                     request+='&color_'+model_parts[i].render_slug+'=10'
                                 //  params['color_'+model_parts[i].render_slug]=10
                                 }
                                 else {
                                     request+='&color_'+model_parts[i].render_slug+'=23'
                                 //params['color_'+model_parts[i].render_slug]=23
                                 }
                                 
                             }
            
                         }
                         else {
                             let founded=false
                             for(let k=0;k<cart_item.order_item_customizations.length;k++)
                             {
                                 if(cart_item.order_item_customizations[k].model_part.id==model_parts[i].id)
                                 {
                                     request+='&color_'+model_parts[i].render_slug+'='+cart_item.order_item_customizations[k].color.id
                                 // params['color_'+model_parts[i].render_slug]=cart_item.order_cart_item_customizations[k].color.id
                             
                                 founded=true
                                 }
                             }
    
                             if(founded==false) {
                                 if(model_parts[i].material=="plastic")
                                 {
                                     request+='&color_'+model_parts[i].render_slug+'=10'
                                 }
                                 else {
                                     request+='&color_'+model_parts[i].render_slug+'=19'
                                 }
                             
                             }
            
                         }
            
                         request+='&texture_'+model_parts[i].render_slug+'=4'
        
                     }
                             else if(model_parts[i].type=='texture_color') {
                                 if(model_parts[i].render_slug=="frame")
                                 {
                     
                                     // ON parcoure les order cart_item customizations pour voir si il y a le meme id que le model part courant
                                     let founded=false
                                     // Si oui on precise le param
                                     for(let k=0;k<cart_item.order_item_customizations.length;k++)
                                     {
                     
                                         if(cart_item.order_item_customizations[k].model_part.id==model_parts[i].id)
                                         {
                         
                                             founded=true
                                 
                                             request+='&color_'+model_parts[i].render_slug+'='+cart_item.order_item_customizations[k].color.id
 
                                             if(cart_item.order_item_customizations[k].texture_style)
                                             {
                                                 request+='&texture_style_'+model_parts[i].render_slug+'='+cart_item.order_item_customizations[k].texture_style.id
                                             }
                                             else 
                                             {
                                                 request+='&texture_style_'+model_parts[i].render_slug+'=0'
                                             }
 
                                             if(cart_item.order_item_customizations[k].texture)
                                             {
                                                 request+='&texture_'+model_parts[i].render_slug+'='+cart_item.order_item_customizations[k].texture.id
                                             }
                                             else 
                                             {
                                                 request+='&texture_'+model_parts[i].render_slug+'=4'
                                             }
                         
                         //params['texture_style_'+model_parts[i].render_slug]=
                         
                         //params['texture_'+model_parts[i].render_slug]=cart_item.order_cart_item_customizations[k].texture ? cart_item.order_cart_item_customizations[k].texture.id : 4
                                         }
                         
                                     }
             
                                     if(founded==false) {
                                         if(model_parts[i].material=="plastic")
                                         {
                                             request+='&color_'+model_parts[i].render_slug+'=10'
                                         // params['color_'+model_parts[i].render_slug]=10
                                         }
                                         else {
                                             request+='&color_'+model_parts[i].render_slug+'=19'
                                         //params['color_'+model_parts[i].render_slug]=19
                                         }
                                         
                                         request+='&texture_style_'+model_parts[i].render_slug+'=0'
                                         request+='&texture_'+model_parts[i].render_slug+'=4'
 
                                         // params['texture_style_'+model_parts[i].render_slug]= 0
                                     
                                         // params['texture_'+model_parts[i].render_slug]=4
                                     }
                     
                                 }
                                 else if(model_parts[i].render_slug=="temples") {
                                     let founded=false
                                     for(let k=0;k<cart_item.order_item_customizations.length;k++)
                                     {
                                         if(cart_item.order_item_customizations[k].model_part.id==model_parts[i].id)
                                         {
                                             request+='&color_'+model_parts[i].render_slug+'='+cart_item.order_item_customizations[k].color.id
                                         //params['color_'+model_parts[i].render_slug]=cart_item.order_cart_item_customizations[k].color.id
 
                                         if(cart_item.order_item_customizations[k].texture)
                                         {
                                             request+='&texture_'+model_parts[i].render_slug+'='+cart_item.order_item_customizations[k].texture.id
                                         }
                                         else 
                                         {
                                             request+='&texture_'+model_parts[i].render_slug+'=4'
                                         }
 
                                         request+='&texture_style_'+model_parts[i].render_slug+'=0'
                                         //params['texture_style_'+model_parts[i].render_slug]= 0
                                         founded=true
                                         }
                                     }
             
                                     if(founded==false) {
                                         if(model_parts[i].material=="plastic")
                                         {
                                             request+='&color_'+model_parts[i].render_slug+'=10'
                                         // params['color_'+model_parts[i].render_slug]=10
                                         }
                                         else {
                                             request+='&color_'+model_parts[i].render_slug+'=23'
                                         //params['color_'+model_parts[i].render_slug]=23
                                         }
 
                                         request+='&texture_'+model_parts[i].render_slug+'=4'
                             
                                         //params['texture_'+model_parts[i].render_slug]= 4
 
                                         request+='&texture_style_'+model_parts[i].render_slug+'=0'
                                         //params['texture_style_'+model_parts[i].render_slug]= 0
                                     }
                     
                     
                                 }
                             else {
                                 let founded=false
                                 for(let k=0;k<cart_item.order_item_customizations.length;k++)
                                 {
                                     if(cart_item.order_item_customizations[k].model_part.id==model_parts[i].id)
                                     {
 
                                         request+='&color_'+model_parts[i].render_slug+'='+cart_item.order_item_customizations[k].color.id
                                     // params['color_'+model_parts[i].render_slug]=cart_item.order_cart_item_customizations[k].color.id
                                 
                                     founded=true
                                     }
                                 }
                         
                                 if(founded==false) {
                                     if(model_parts[i].material=="plastic")
                                     {
                                         request+='&color_'+model_parts[i].render_slug+'=10'
                                     // params['color_'+model_parts[i].render_slug]=10
                                     }
                                     else {
                                         request+='&color_'+model_parts[i].render_slug+'=19'
                                     //params['color_'+model_parts[i].render_slug]=19
                                     }
                                 
                                 }
                                 request+='&texture_'+model_parts[i].render_slug+'=4'
                     //params['texture_'+model_parts[i].render_slug]=4
                     
                             }
                     
                     
                         }
                         else if (model_parts[i].render_type=="lense")
                         {
 
                             if(cart_item.tint)
                         {
                             request+='&tint_'+model_parts[i].render_slug+'='+cart_item.tint.id
                         // params['color_'+model_parts[i].render_slug]=10
                         }
                         else {
                             request+='&tint_'+model_parts[i].render_slug+'=5'
                         //params['color_'+model_parts[i].render_slug]=19
                         }
                     
                     
                 
                         }
                 
                 
                 }
             }
 
             let datas = await APIRequest.list_renders('photos-layers-new', request)
                     //let render_infos =  await APIRequest.list_renders('photos-layers-new',request)
                     //let render_infos_datas=render_infos
 
             const sceneData = datas.scene1
 
             // Set photoDatas first so images can start loading
             this.photoDatas = sceneData
 
             // Wait for next tick to ensure images are in DOM
             await this.$nextTick()
             
             // Wait for all images to load
             await this.waitForImagesToLoad()
 
             // Convert all images to base64 AFTER they're loaded
             if (sceneData && sceneData.length > 0) {
                 
                 const conversionResults = await Promise.all(
                     sceneData.map(async (layer_info, index) => {
                         const url = this.getPhotoUrl(layer_info)
                    
                         const base64 = await this.convertImageToBase64(url)
                         
                         // Verify it's actually base64
                         if (base64 && base64.startsWith('data:')) {
                             
                             // Store base64 directly in layer_info for immediate use using Vue.set for reactivity
                             this.$set(layer_info, 'base64', base64)
                             // Also ensure it's in cache
                             if (!this.base64Cache[url]) {
                                 this.$set(this.base64Cache, url, base64)
                             }
                         } else {
                             console.warn(`⚠ Image ${index + 1} conversion failed, using URL fallback`)
                         }
                         return base64
                     })
                 )
                 const successCount = conversionResults.filter(b => b && b.startsWith('data:')).length
                
                 // Emit event when conversion is complete
                 this.allImagesConverted = successCount === sceneData.length
                 this.$emit('images-converted', {
                     total: sceneData.length,
                     converted: successCount,
                     allConverted: this.allImagesConverted
                 })
             }
 
             this.loading=false
 
            
             
         },
         getPhotoUrl(layer_info) {
             let hue = layer_info.presets.hue_app ? layer_info.presets.hue_app : 100
             let saturation = layer_info.presets.saturation ? layer_info.presets.saturation : 100
             let brightness = layer_info.presets.brightness ? layer_info.presets.brightness : 100
            
 
             let url
             if(brightness==100 && hue==100 && saturation==100)
             {
             url = 'https://api.sens-eye.fr/render_parts/'+layer_info.render
             }
             else {
             url = 'https://api.sens-eye.fr/api/photo-single-test?photo='+layer_info.render+'&hue='+hue+'&saturation='+saturation+'&brightness='+brightness
             }
           
             return url
         },
         calculatePhoto(layer_info) {
             // First check if base64 is already stored in layer_info
             if (layer_info.base64) {
                 return layer_info.base64
             }
             
             const url = this.getPhotoUrl(layer_info)
             
             // Return base64 if cached, otherwise return original URL
             return this.base64Cache[url] || url
         },
         async convertImageToBase64(url) {
             try {
                 // Check if already cached
                 if (this.base64Cache[url]) {
                     return this.base64Cache[url]
                 }
 
                 // Check if URL is already a data URL (base64)
                 if (url.startsWith('data:')) {
                     this.$set(this.base64Cache, url, url)
                     return url
                 }
 
                 // Try to find already loaded image in DOM first
                 const existingImg = this.findLoadedImageInDOM(url)
                 if (existingImg && existingImg.complete) {
                     try {
                         const base64 = await this.convertLoadedImageToBase64(existingImg)
                         this.$set(this.base64Cache, url, base64)
                         return base64
                     } catch (e) {
                         console.warn('Failed to convert loaded image, trying other methods:', e)
                     }
                 }
 
                 // Try fetch with CORS proxy as fallback
                 try {
                     // Try direct fetch first
                     const response = await fetch(url, {
                         mode: 'cors',
                         credentials: 'omit'
                     })
                     
                     if (!response.ok) {
                         throw new Error(`HTTP error! status: ${response.status}`)
                     }
                     
                     const blob = await response.blob()
                     
                     // Convert blob to base64
                     return new Promise((resolve, reject) => {
                         const reader = new FileReader()
                         reader.onloadend = () => {
                             const base64String = reader.result
                             // Use Vue.set for reactivity
                             this.$set(this.base64Cache, url, base64String)
                             resolve(base64String)
                         }
                         reader.onerror = () => {
                             reject(new Error('Failed to read image as base64'))
                         }
                         reader.readAsDataURL(blob)
                     })
                 } catch (fetchError) {
                     // If fetch fails (CORS issue), try using CORS proxy
                     console.warn('Direct fetch failed (CORS), trying proxy method:', fetchError)
                     return this.convertImageToBase64ViaProxy(url)
                 }
             } catch (error) {
                 console.error('Error converting image to base64:', error, url)
                 // Fallback to original URL on error
                 this.$set(this.base64Cache, url, url)
                 return url
             }
         },
         findLoadedImageInDOM(url) {
             // Find if this image is already loaded in the DOM
             const images = this.$el ? this.$el.querySelectorAll('img') : []
             for (let img of images) {
                 if (img.src === url || img.src.includes(url.split('/').pop())) {
                     return img
                 }
             }
             return null
         },
         convertLoadedImageToBase64(imgElement) {
             return new Promise((resolve, reject) => {
                 try {
                     const canvas = document.createElement('canvas')
                     canvas.width = imgElement.naturalWidth || imgElement.width
                     canvas.height = imgElement.naturalHeight || imgElement.height
                     const ctx = canvas.getContext('2d')
                     
                     // Try to draw the image
                     ctx.drawImage(imgElement, 0, 0)
                     
                     // Convert to base64
                     const base64String = canvas.toDataURL('image/png')
                     resolve(base64String)
                 } catch (error) {
                     // If canvas is tainted (CORS), try alternative method
                     reject(error)
                 }
             })
         },
         waitForImagesToLoad() {
             return new Promise((resolve) => {
                 if (!this.$el) {
                     resolve()
                     return
                 }
                 
                 const images = this.$el.querySelectorAll('img')
                 if (images.length === 0) {
                     resolve()
                     return
                 }
                 
                 let loadedCount = 0
                 const totalImages = images.length
                 
                 const checkComplete = () => {
                     loadedCount++
                     if (loadedCount >= totalImages) {
                        
                         resolve()
                     }
                 }
                 
                 images.forEach((img) => {
                     if (img.complete) {
                         checkComplete()
                     } else {
                         img.addEventListener('load', checkComplete, { once: true })
                         img.addEventListener('error', checkComplete, { once: true })
                     }
                 })
                 
                 // Timeout after 10 seconds
                 setTimeout(() => {
                     console.warn('Image loading timeout, proceeding anyway')
                     resolve()
                 }, 10000)
             })
         },
         async convertImageToBase64ViaProxy(url) {
             // Try using proxy methods to bypass CORS
             // In development, vue.config.js has a proxy to api.sens-eye.fr
             // In production, you need either:
             // 1. Configure CORS headers on the API server
             // 2. Set up a backend proxy endpoint
             // 3. Use a CORS proxy service (not recommended for production)
             
             const isDevelopment = process.env.NODE_ENV === 'development'
             const proxyUrls = []
             
             // In development, try using the dev server proxy
             if (isDevelopment && url.includes('api.sens-eye.fr')) {
                 // Extract the path from the full URL
                 const urlPath = url.replace('https://api.sens-eye.fr', '')
                 proxyUrls.push(urlPath) // This will go through the dev server proxy
             }
             
             // Add your own backend proxy endpoint if available
             // proxyUrls.push(`/api/proxy-image?url=${encodeURIComponent(url)}`)
             
             // Public proxy as last resort (not recommended for production)
             proxyUrls.push(`https://api.allorigins.win/raw?url=${encodeURIComponent(url)}`)
             
             for (const proxyUrl of proxyUrls) {
                 try {
                     const response = await fetch(proxyUrl, {
                         method: 'GET',
                         headers: {
                             'Accept': 'image/*'
                         }
                     })
                     
                     if (!response.ok) {
                         console.warn(`Proxy returned ${response.status} for ${proxyUrl}`)
                         continue
                     }
                     
                     const blob = await response.blob()
                     
                     // Verify it's an image
                     if (!blob.type.startsWith('image/')) {
                         console.warn('Proxy returned non-image data')
                         continue
                     }
                     
                     return new Promise((resolve, reject) => {
                         const reader = new FileReader()
                         reader.onloadend = () => {
                             const base64String = reader.result
                             this.$set(this.base64Cache, url, base64String)
                       
                             resolve(base64String)
                         }
                         reader.onerror = () => {
                             reject(new Error('Failed to read image as base64'))
                         }
                         reader.readAsDataURL(blob)
                     })
                 } catch (error) {
                     console.warn('Proxy fetch failed:', error.message)
                     continue
                 }
             }
             
             // If all proxies fail, try canvas method as last resort
             console.warn('All proxy methods failed, trying canvas method (will likely fail due to CORS)')
             return this.convertImageToBase64ViaCanvas(url)
         },
         convertImageToBase64ViaCanvas(url) {
             return new Promise((resolve, reject) => {
                 const img = new Image()
                 img.crossOrigin = 'anonymous'
                 
                 img.onload = () => {
                     try {
                         const canvas = document.createElement('canvas')
                         canvas.width = img.width
                         canvas.height = img.height
                         const ctx = canvas.getContext('2d')
                         ctx.drawImage(img, 0, 0)
                         
                         const base64String = canvas.toDataURL('image/png')
                         this.$set(this.base64Cache, url, base64String)
                         resolve(base64String)
                     } catch (error) {
                         console.error('Canvas conversion error (likely CORS taint):', error)
                         // Canvas is tainted, can't read it
                         reject(error)
                     }
                 }
                 
                 img.onerror = () => {
                     console.error('Image load error for:', url)
                     reject(new Error('Failed to load image'))
                 }
                 
                 img.src = url
             })
         },
         
                 
     },
     data(){
       
         return{
             photoDatas:null,
             model_parts:null,
             photosLoaded:0,
             loading:true,
             base64Cache: {},
             allImagesConverted: false
         }
     },
     computed: {
     
     
     },
     async mounted(){
         await this.getModelParts()
         await this.getRenderInfos()
     }
 }
 </script>
 
 <style scoped>
 
 .loader-image {
     position:absolute;
     top:0;
     left:0;
     z-index:10;
 }
 .product-img-inner {
     position:absolute;
     top:0;
     left:0;
 }
 .product-img img {
     width:100%;
     height:auto;
 
 }
 .product-img {
     position:relative;
 
 }
 </style>